<ng-container *ngIf="loading">
  <edp-loader [size]="'md'" [position]="'center'"></edp-loader>
</ng-container>

<div class="overlay-benefits" *ngIf="!loading">
  <div class="overlay-benefits-header">
    {{'pt.edp.edponline.widget.partners.title' | translate | uppercase}} </div>
  <div class="overlay-benefits-body">
    <edp-savings [allDiscounts]="discounts" ></edp-savings>
    <edp-partnerships [allPartnerships]="partnerships" (closeSideBar)="close()" ></edp-partnerships>
  </div>
</div>
